import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import HeaderContainer from "@/my_components/Header/HeaderContainer";
import Separator from "@/components/Common/Separator";
// import EventsOnSmartTech from "@/my_components/_Events/EventsOnSmartTech";
import MobileMenu from "@/my_components/Header/MobileMenu";
import BackToTop from "@/my_components/BackToTop/BackToTop_1";

import BlogDetails from "@/my_components/_BlogDetails/BlogDetails";

import Footer from "@/my_components/Footer/Footer";




const index = () => {




  return (

    <>

        <PageHead title="Blog Post | SmartTech Academy" />

            <Context>
                <MobileMenu />
                <HeaderContainer headerSticky="" headerType="" />
                <BlogDetails />


                <BackToTop />

                <Separator />
                <Footer />
            </Context>
    </>

  );

};

export default index;
